/*
         * @ngdoc function
         * @name ePay.Model:Session_PaymentPageModel
         * @description
         * Model
         */
import { Session_ACHModel } from './Session_ACHModel';
import { Session_CardDataModel } from './Session_CardDataModel';
import { Session_AppleModel } from './Session_AppleModel';
import { Session_AppleSubmissionModel } from './Session_AppleSubmissionModel';
import { Token } from '../Token';
import { Session_Credit_Card_RequestModel } from './Session_Credit_Card_RequestModel';
import { Session_Credit_Card_ResponseModel } from './Session_Credit_Card_ResponseModel';

export class Session_PaymentPageModel {
  iFrame: boolean | null | undefined;
  company: string | null | undefined;
  firstName: string | null | undefined;
  lastName: string | null | undefined;
  outsideUS: boolean | null | undefined;
  address1: string | null | undefined;
  address2: string | null | undefined;
  city: string | null | undefined;
  state: string | null | undefined;
  zipCode: string | null | undefined;
  phone: string | null | undefined;
  email: string | null | undefined;
  amount: number | null | undefined;
  serviceAmount: number | null | undefined;
  totalAmount: number | null | undefined;
  paymentOption: number | null | undefined;
  merchantIdentifier: string | null | undefined;
  thumbprint: string | null | undefined;
  token_Request: Token[] | null | undefined;
  ach: Session_ACHModel | null | undefined;
  bankStatement: string | null | undefined;
  apple: Session_AppleModel | null | undefined;
  appleSubmissionText: string | null | undefined;
  appleSubmission: Session_AppleSubmissionModel | null | undefined;
  credit_card: Array<Session_Credit_Card_RequestModel> | null | undefined;
  cardHolderName: string | null | undefined;
  cardData: Session_Credit_Card_ResponseModel | null | undefined;
  captchakey: string | null | undefined;
  captchaaction: string | null | undefined;
  googleMerchantId: string | null | undefined;
  gatewayMerchantId: string | null | undefined;
  environment: string | null | undefined;
  merchantName: string | null | undefined;

  constructor(
    iFrame?: boolean,
    company?: string,
    firstName?: string,
    lastName?: string,
    outsideUS?: boolean,
    address1?: string,
    address2?: string,
    city?: string,
    state?: string,
    zipCode?: string,
    phone?: string,
    email?: string,
    amount?: number,
    serviceAmount?: number,
    totalAmount?: number,
    paymentOption?: number,
    googleMerchantId?: string,
    merchantIdentifier?: string,
    thumbprint?: string,
    token_Request?: Token[],
    ach?: Session_ACHModel,
    bankStatement?: string,
    apple?: Session_AppleModel,
    appleSubmissionText?: string,
    appleSubmission?: Session_AppleSubmissionModel,
    card_connect?: Array<Session_Credit_Card_RequestModel>,
    cardHolderName?: string,
    cardData?: Session_Credit_Card_ResponseModel,
    captchakey?: string,
    captchaaction?: string
  ) {
    this.iFrame = iFrame || null;
    this.company = company || null;
    this.firstName = firstName || null;
    this.lastName = lastName || null;
    this.outsideUS = outsideUS || null;
    this.address1 = address1 || null;
    this.address2 = address2 || null;
    this.city = city || null;
    this.state = state || null;
    this.zipCode = zipCode || null;
    this.phone = phone || null;
    this.email = email || null;
    this.amount = amount || null;
    this.serviceAmount = serviceAmount || null;
    this.totalAmount = totalAmount || null;
    this.paymentOption = paymentOption || null;
    this.merchantIdentifier = merchantIdentifier || null;
    this.thumbprint = thumbprint || null;
    this.token_Request = token_Request || [];
    this.ach = ach || new Session_ACHModel();
    this.bankStatement = bankStatement || null;
    this.apple = apple || new Session_AppleModel();
    this.appleSubmissionText = appleSubmissionText || null;
    this.appleSubmission = appleSubmission || new Session_AppleSubmissionModel();
    this.credit_card = card_connect || [];
    this.cardHolderName = cardHolderName || null;
    this.cardData = cardData || new Session_Credit_Card_ResponseModel();
    this.captchakey = captchakey || null;
    this.captchaaction = captchaaction || null;
    this.googleMerchantId = googleMerchantId || null;
  }
}
